import React from "react";

// import components
import Header from "./Header";
import Nav from "./Nav";
import About from "./About";
import Team from "./Team";
import ContactForm from "./ContactForm";
import Reviews from "./Reviews";
import HbGuide from "./HbGuide";
import Calculators from "./Calculators";
import Location from "./Location";
import Footer from "./Footer";
import StrategicLending from "./StrategicLending";
import TradLoanPrograms from "./TradLoanPrograms";
import PortLoanPrograms from "./PortLoanPrograms";
import ConstructionLoanPrograms from "./ConstructionLoanPrograms";

// import styled components
import { Grid } from "../styled";

const BranchSingle = ({ branch, path }) => {
  if (path === "/Schumacher") {
    return <h1>Schumacher</h1>;
  }

  const {
    address,
    aboutProfile,
    coordinates,
    description,
    googleAddress,
    id,
    members = [],
    name,
    owner = { account: "" },
    photoUrl,
    sectionImageUrl,
    telephoneNumber,
  } = branch;

  return (
    <>
      <Header backgroundImage={photoUrl} name={name} id={id} />
      <Nav />
      <main>
        <About description={description} featuredProfile={aboutProfile} sectionImage={sectionImageUrl} name={name} />
        {/* <Grid>
          <Team members={members} />
        </Grid> */}
        <ContactForm />
        <StrategicLending />
        <ConstructionLoanPrograms />
        <PortLoanPrograms />
        <TradLoanPrograms />
        <Reviews />
        {/* <HbGuide name={name} account={owner.account} /> */}
        <Calculators />
        <Location
          address={address}
          googleAddress={googleAddress}
          coordinates={coordinates}
          name={name}
          telephoneNumber={telephoneNumber}
        />
        <Footer />
      </main>
    </>
  );
};

export default BranchSingle;
